import React from 'react';
import { TrendingUpIcon, TrendingDownIcon, TargetIcon } from 'lucide-react';
const formatValue = (value, format) => {
  switch (format) {
    case 'number':
      return value.toLocaleString();
    case 'percent':
      return `${(value * 100).toFixed(1)}%`;
    case 'currency':
      return `ETB ${(value / 1000000).toFixed(1)}M`;
    case 'time':
      return `${value} days`;
    default:
      return value.toString();
  }
};
const getStatusColor = (value, threshold = 0.8) => {
  if (value >= threshold) return 'text-green-400';
  if (value >= threshold - 0.2) return 'text-yellow-400';
  return 'text-red-400';
};
const KPICard = ({
  title,
  value,
  change,
  target,
  progress,
  format = 'number',
  type = 'value'
}) => {
  return <div className="bg-slate-700 rounded-lg p-4 flex flex-col" data-id="element-91">
      <h3 className="text-sm text-slate-300 mb-2" data-id="element-92">{title}</h3>
      <div className="text-2xl font-bold mb-1" data-id="element-93">
        {formatValue(value, format)}
      </div>
      {type === 'trend' && change !== undefined && <div className={`flex items-center text-sm ${change >= 0 ? 'text-green-400' : 'text-red-400'}`} data-id="element-94">
          {change >= 0 ? <TrendingUpIcon size={16} className="mr-1" data-id="element-95" /> : <TrendingDownIcon size={16} className="mr-1" data-id="element-96" />}
          {change >= 0 ? '+' : ''}
          {(change * 100).toFixed(1)}% vs prev
        </div>}
      {type === 'progress' && progress !== undefined && <div className="mt-2" data-id="element-97">
          <div className="flex justify-between text-xs mb-1" data-id="element-98">
            <span data-id="element-99">{formatValue(value, format)}</span>
            <span className="flex items-center" data-id="element-100">
              <TargetIcon size={12} className="mr-1" data-id="element-101" />
              {formatValue(target, format)}
            </span>
          </div>
          <div className="w-full bg-slate-600 rounded-full h-2" data-id="element-102">
            <div className={`h-2 rounded-full ${getStatusColor(progress)}`} style={{
          width: `${progress * 100}%`
        }} data-id="element-103"></div>
          </div>
        </div>}
    </div>;
};
export default KPICard;